import React from 'react'
import MarketInstrumentPage from './MarketInstrumentPage'

export default function Energies() {
  return (
    <MarketInstrumentPage
      activeMarket="Energies"
      heroSymbol="Oil"
      name="Energies"
      tagline="Trade crude oil and other energy commodities with speed and flexibility."
      heroImageLabel="oil rig / energy market background"
      descriptionImageLabel="trader viewing energy charts on laptop and mobile"
      description={{
        title: 'Tap Into The Energy Markets',
        paragraphs: [
          'Energy commodities like Brent Crude and WTI Crude Oil are traded daily by market participants reacting to supply data, geopolitical developments, and shifting global demand.',
          'With Xperia Capital energy CFDs, you can take a position on price direction with speed and flexibility, without needing to manage physical delivery or storage.',
        ],
      }}
      conditions={[
        { symbol: 'XBR/USD', desc: 'Brent Crude Oil', minSpread: { STD: '0.04', ECN: '0.02', PRO: '0.01' }, avgSpread: { STD: '0.05', ECN: '0.03', PRO: '0.02' }, pipValue: '10.00', minMove: '0.001', contractValue: '1,000 bbl' },
        { symbol: 'XTI/USD', desc: 'WTI Crude Oil', minSpread: { STD: '0.04', ECN: '0.02', PRO: '0.01' }, avgSpread: { STD: '0.05', ECN: '0.03', PRO: '0.02' }, pipValue: '10.00', minMove: '0.001', contractValue: '1,000 bbl' },
      ]}
      whyTrade={[
        { icon: 'barChart', title: 'High Volatility', desc: 'Energy markets can move quickly, creating frequent trading opportunities.' },
        { icon: 'shield', title: 'Hedge Exposure', desc: 'Offset broader portfolio risk tied to energy-sensitive sectors.' },
        { icon: 'globe', title: 'Global Signals', desc: 'React to supply decisions, inventory data, and geopolitical events.' },
        { icon: 'trendUp', title: 'Leverage Available', desc: 'Manage position size relative to your account balance.' },
      ]}
      faqs={[
        { q: 'What is energy trading?', a: 'Energy trading involves speculating on the price of commodities like crude oil and natural gas via CFDs, without taking physical delivery of the underlying commodity.' },
        { q: 'What commodities are available?', a: 'Xperia Capital currently offers Brent Crude Oil and WTI Crude Oil, with more energy instruments planned.' },
        { q: 'What moves energy prices?', a: 'Supply and demand data, OPEC+ decisions, inventory reports, and geopolitical events are major drivers of oil price movement.' },
        { q: 'Is energy trading suitable for beginners?', a: 'Energy markets can be more volatile than other asset classes, so it is important to understand the risks and start with a size you are comfortable with.' },
      ]}
    />
  )
}
